'use strict';

/* globals window */

var _ = require('lodash');
var React = require('react');

var Page = require('../page.jsx');
var ItemStore = require('../store/items');
var PostStore = require('../store/posts');
var AdvertiseStore = require('../store/advertise');
var CardStore = require('../store/card');
var at = require('../utils/environment');

var exposed = {
    itemStore: null,
    postStore: null,
    advertiseStore: null
};

var Pagination = {

    statics: {
        _exposed: function() {
            return exposed;
        }
    },

    getInitialState: function() {
        this.cardStore = null;

        var configPostStore = {
            feedId: this.getFeedId(),
            posts: this.props.items,
            nextPage: this.props.nextPage
        };

        if (at.client) {
            configPostStore.isRecommended = this.isRecommended();
            configPostStore.recommendationUrl = this.getRecommendationUrl();
            configPostStore.isAutoLoadMoreActive = this.isAutoLoadMoreActive;

            this.advertiseStore = new AdvertiseStore();
            this.cardStore = new CardStore(this);
        }

        this.postStore = new PostStore(configPostStore);

        if (at.client && this.isRecommended()) {
            this.postStore._posts = [];
        }

        this.setupRhythm();
        this.itemStore = new ItemStore(this.buildPage());
        this.updateTotalRenderedItems();

        if (at.client) {
            this.exposeStores();
        }

        return null;
    },

    exposeStores: function() {
        for (var n in exposed) exposed[n] = this[n];
    },

    isRecommended: function() {
        var BASTIAN = this.getBastianSettings();
        return this.props.isRecommended || BASTIAN.IS_RECOMMENDED || false;
    },

    getRecommendationUrl: function() {
        var BASTIAN = this.getBastianSettings();
        return this.props.recommendationUrl || BASTIAN.RECOMMENDATION_URL || '';
    },

    getBastianSettings: function() {
        if (at.client && window.SETTINGS && window.SETTINGS.BASTIAN)
            return window.SETTINGS.BASTIAN;
        else return {};
    },

    componentDidMount: function() {
        this.itemStore.on('change', this.itemsChanged);
        this.postStore.on('restocked', this.update);
        this.postStore.on('remove-posts', this.removeRenderedPosts);
        this.postStore.on('unmount-load-more', this.unmountLoadMore);
        if (this.cardStore) this.cardStore.bindEvents();
    },

    componentWillUnmount: function() {
        this.itemStore.removeListener('change', this.itemsChanged);
        this.postStore.removeListener('restocked', this.update);
        this.postStore.removeListener('remove-posts', this.removeRenderedPosts);
        if (this.cardStore) this.cardStore.unbindEvents();
    },

    itemsChanged: function() {
        this.updateTotalRenderedItems();
        this.update();
    },

    update: function() {
        this.forceUpdate();
    },

    removeRenderedPosts: function() {
        this.itemStore._renderedItems = [];
        this.itemStore.grantItemKey(this.postStore._posts);
        this.itemStore.emit('change');
    },

    unmountLoadMore: function() {
        this.postStore.removeListener('unmount-load-more', this.unmountLoadMore);
        this.update();
    },

    getPagesData: function() {
        if (this.itemStore)
            return _.chunk(this.itemStore.all(), this._maxItemsPerRender);
        else return [];
    },

    renderPages: function() {
        return _.map(this.getPagesData(), this.createPage);
    },

    createPage: function(items, index) {
        return <Page key={index + 1} pageIndex={index + 1} items={items} executeAfterMount={this.playAutoLoadMore} />;
    },

    getNextPageIndex: function() {
        var initalPageIndex = this.getInitialPageIndex();
        var totalRenderable = this.getPagesData().length;
        var nextPageIndex = initalPageIndex + totalRenderable;

        /**
          * Next page should never be equal to current page even if
          * the render fails, because search bots need to foward already
          * known pages.
          */
        if (totalRenderable === 0) nextPageIndex += 1;

        if (this.hasNextPage()) return nextPageIndex;
        else return null;
    },

    hasNextPage: function() {
        if (this.isRecommended() && this.postStore._hasNextPage)
            return true;

        if (this.postStore.isEmpty() === false)
            return true;

        if (at.server || this.itemStore.all().length < this._maxItemsPerRender)
            return Boolean(this.props.nextPage);

        return false;
    },

    getInitialPageIndex: function() {
        var nextPageIndex = (this.props.nextPage || 2);
        return (nextPageIndex - 1);
    }
};

module.exports = Pagination;
